import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'a[ui-m040-c040-promotion-banner], button[ui-m040-c040-promotion-banner]',
    exportAs: 'promotionBanner',
    standalone: true,
    imports: [],
    templateUrl: './m040-c040-promotion-banner.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'bg-blue block hover:cursor-pointer',
    },
})
export class M040C040PromotionBannerComponent {}
